<div
  class="a-link {{ linkSizMap[size] }}"
  [class.-disabled]="disabled"
  [class.highlight]="highlight"
  [class.-icon]="hasIcon$ | async"
  [class.a-link--integrated]="type === 'integrated'"
  [class.a-link--button]="type === 'button'"
  [class.a-link--button-secondary]="type === 'button-secondary'"
  [class.a-link--button-integrated]="type === 'button-integrated'"
>
  @if (href){
  <a [href]="href" [target]="target"> <ng-container *ngTemplateOutlet="content"></ng-container> </a>
  } @if(routerLink){
  <a routerLink="{{ routerLink }}" [queryParams]="queryParams" [target]="target">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
  }

  <ng-template #content>
    <ng-content select="[prefix]"></ng-content>
    <span>
      <ng-content></ng-content>
    </span>
    <ng-content select="[postfix]"></ng-content>
  </ng-template>
</div>
